import base from './configService'

const enterpriseGeoService = {}

enterpriseGeoService.getEnterpriseGeo = function () {
    return base.get('/Enterprises/enterpriseGeo/get')
      .then(res => {
        return res.data;
      })
      .catch(e => {
        return Promise.reject(e);
      })
}

enterpriseGeoService.updateEnterpriseGeo = function (data) {
  return base.put('/Enterprises/enterpriseGeo/update', data)
    .then(res => {
      return res.data;
    })
    .catch(e => {
      return Promise.reject(e);
    })
}
export default enterpriseGeoService
// enterpriseGeoServices.setEnterpriseGeo = function (data) {
//   return base.post('/Enterprises/enterpriseGeo/create', data)
//     .then(res => {
//       return res.data;
//     })
//     .catch(e => {
//       return Promise.reject(e);
//     })
// }



